import React, { PureComponent } from 'react';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import BundleProductListLoaderContext from './BundleProductListContext';
import { StyledPaginatedListSkeleton } from '../styles/BundleProductListView.style';

class BundleProductListLoadingComponent extends PureComponent {
  render() {
    return (
      <BundleProductListLoaderContext.Consumer>
        {(bundleProductsLength) =>
          bundleProductsLength ? (
            [...Array(bundleProductsLength)].map(() => (
              <StyledPaginatedListSkeleton>
                <div className="list-skeleton-container">
                  <LoaderSkelton className="image-skeleton" />
                  <div className="bundle-product-list-details-skeleton">
                    <LoaderSkelton className="bundle-product-list-title-skeleton" />
                    <div className="bundle-product-list-skeleton">
                      <LoaderSkelton height={'143px'} />
                      <LoaderSkelton height={'42px'} />
                    </div>
                  </div>
                </div>
                <div className="horizontal-separator" />
              </StyledPaginatedListSkeleton>
            ))
          ) : (
            <></>
          )
        }
      </BundleProductListLoaderContext.Consumer>
    );
  }
}

export default BundleProductListLoadingComponent;
